const copFormatter = new Intl.NumberFormat('es-CO', {
    style: 'currency',
    currency: 'COP',
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
});

/** Formato pesos colombianos (COP). Valores no válidos o ≤ 0 → em dash. */
export function formatCOP(value) {
    const n = Number(value);
    if (!Number.isFinite(n) || n <= 0) return '—';
    return copFormatter.format(Math.round(n));
}

/** COP incluso si el valor es 0 (útil en totales de simulación). */
export function formatCOPAllowZero(value) {
    const n = Number(value);
    if (!Number.isFinite(n)) return '—';
    return copFormatter.format(Math.round(n));
}
